import React from 'react'

function Social() {
  return (
    <div className="home_social">
        <a href="https://www.instagram.com/victor_aszs/" className="home_social-icon" target="_blank">
        <i className="uil uil-instagram"></i>
        </a>
        <a href="https://api.whatsapp.com/send?phone=5554984289836&text=Ol%C3%A1,%20temos%20interesse%20em%20contratar%20voc%C3%AA." className="home_social-icon" target="_blank">
        <i class="uil uil-whatsapp"></i>
        </a>
        <a href="https://github.com/VictorAsz" className="home_social-icon" target="_blank">
        <i className="uil uil-github"></i>
        </a>
    </div>
  )
}

export default Social